/**
 *
 * getSagasConfig Function
 *
 */

export default function getSagasConfig() {
  return {};
}
